const normalizeRole = (role) => ({
  id: role?.id ?? role?._id,
  name: role?.name ?? role?.roleName ?? "",
  description: role?.description ?? "",
  status: role?.status ?? "Active",
  usersCount: role?.usersCount ?? role?.userCount ?? 0,
});

export function normalizeRolesListResponse(raw) {
  const data = raw?.data ?? raw;
  const list = Array.isArray(data) ? data : (data?.data ?? data?.list ?? []);
  const meta = data?.meta ?? raw?.meta ?? null;
  return {
    list: Array.isArray(list) ? list.map(normalizeRole) : [],
    meta,
    totalCount: meta?.totalCount ?? meta?.total ?? (Array.isArray(list) ? list.length : 0),
  };
}

export function normalizeRoleItemResponse(raw) {
  const data = raw?.data ?? raw;
  const item = Array.isArray(data) ? data[0] : data;
  return normalizeRole(item || {});
}
